class Sharing {
    init() {
        let self = this;

        self.copyShareLink();
        self.modalSocialShare();
    }

    copyShareLink() {
        let inputLink = $('.sharer .permalink input');
        let copyBtn = $('.sharer .permalink button');

        const doCopy = function () {
            inputLink.trigger('select');
            document.execCommand('copy');
            copyBtn.html('Copié');
    
            setTimeout(function () {
                copyBtn.html('Copier');
            }, 5000);
        };

        inputLink.on('click', doCopy);
        copyBtn.on('click', doCopy);
    }

    modalSocialShare() {
        let triggerBtn = $('.share-btn');
        let theModal = $('#modal-share');
        let inputLink = theModal.find('.permalink input[type="text"]');

        triggerBtn.on('click', function (e) {
            e.preventDefault();

            let currentUrl = window.location.href;

            inputLink.val(currentUrl);
            theModal.modal('show');
        });
    }
}

export default Sharing;